import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs/Rx';

@Injectable()
export class ModalPasswordService {
    public subject = new Subject();
    public openModalListener$ = this.subject.asObservable();
    constructor() { }

    public getModalListener(){
        return this.openModalListener$;
    }

    public openModalPassword(value){
        this.subject.next(value);
    }
}


// WEBPACK FOOTER //
// ./src/app/common/modal-password/modal-password.service.ts